import '../../../node_modules/rangeslider.js';

//Initialisation des Champs de Type Numeric Slider
(function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { AcfKgNumericSlider : {}});

    w.Kinougarde.AcfKgNumericSlider.init= function(element) {
        var $type =  $(element).find("input[type=range]");
        $($type).rangeslider({
            polyfill: false,
            onInit: function() {
                $(this.$range).siblings('.range-labels').find('output').get(0).textContent = this.value
                $(this.$range).closest("[data-acf-type=kg-numeric-slider]").trigger('acf-field-type-numeric-slider-init');
            },
            onSlide: function() {
                $(this.$range).siblings('.range-labels').find('output').get(0).textContent = this.value
                $(this.$range).closest("[data-acf-type=kg-numeric-slider]").trigger('acf-field-type-numeric-slider-change',[this.value]);
            }
        })      
    }

    $("[data-acf-type=kg-numeric-slider]").each(function(i,el) {
        w.Kinougarde.AcfKgNumericSlider.init(el);
    });
})(window);


